module.exports = __webpack_public_path__ + "static/media/pricing.2e77ca5b.svg";